<template>
  <Fragment>
    <div class="container">
      <span class="tit">Review entry</span>
      <Article
        :article="article"
        :showAuthor="role !== 'reviewer'"
        :term="term"
      ></Article>
    </div>
    <div
      class="container-fluid yellow"
      v-if="['reviewer', 'admin', 'god'].includes(role)"
    >
      <div class="container" v-if="['admin', 'god'].includes(role)">
        <span class="tit">Review Assignments</span>
        <ReviewersForm
          :reviewers="reviewers"
          :reviews="reviews"
        ></ReviewersForm>
        <span
          v-if="(reviews[0].text && reviews[0].text.length > 0) || (reviews[1].text && reviews[1].text.length > 0)"
          class="tit"
          >Reviewing</span
        >
        <ReviewForm
          v-if="reviews[0].text && reviews[0].text.length > 0"
          :disabled="true"
          :review="reviews[0]"
        ></ReviewForm>
        <ReviewForm
          v-if="reviews[1].text && reviews[1].text.length > 0"
          :disabled="true"
          :review="reviews[1]"
        ></ReviewForm>

        <div class="container" v-if="['god', 'admin'].includes(role)">
          <label>STATUS</label>
          <select class="status-select" v-model="status" @change="updateStatus()">
            <option value="5">Needs Corrections</option>
            <option disabled value="10">Submitted</option>
            <option value="40">Refused</option>
            <option value="50">Published</option>
          </select>
        </div>


        <input
          @click="submitReviews()"
          value="Finish"
          type="submit"
          name
        />
      </div>
      <div class="container" v-if="role === 'reviewer'">
        <span class="tit">Reviewing</span>
        <ReviewForm :review="reviews[0]"></ReviewForm>
        <input
          @click="submitReview(reviews[0])"
          value="Finish"
          type="submit"
          name
        />
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Article from "./Article";
import ReviewersForm from "./ReviewersForm";
import ReviewForm from "./ReviewForm";
import { reviewDAO as review } from "./helpers";

export default {
  name: "ReviewPage",
  components: { Fragment, Article, ReviewersForm, ReviewForm },
  data() {
    return {
      article: {},
      reviews: [{}, {}],
      reviewers: [],
      term: "",
      status: 10
    };
  },
  computed: {
    articleId() {
      return parseInt(this.$route.params.id, 10);
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    role() {
      return this.$store.getters.role;
    },
  },
  mounted() {
    if (["god", "admin"].includes(this.role)) {
      this.axios
        .get(process.env.API_BASE_URL + `/reviewers`, {
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.token,
          },
        })
        .then((response) => {
          this.reviewers = response.data;
        });
    }
    this.axios
      .get(process.env.API_BASE_URL + `/reviews/user`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.token,
        },
      })
      .then((response) => {
        const reviews = response.data.filter(
          (review) => review.article_id === this.articleId
        );
        this.reviews = [...new Array(2)].map((_item, idx) => {
          return reviews[idx]
            ? reviews[idx]
            : review({
                article_id: this.articleId,
              });
        });
      });
    this.axios
      .get(process.env.API_BASE_URL + `/articles/${this.articleId}`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.token,
        },
      })
      .then((response) => {
        this.article = response.data;
        this.axios
          .get(process.env.API_BASE_URL + `/terms/${this.article.term_id}`)
          .then((response) => {
            this.term = response.data.term_english;
          });
      });
  },
  methods: {
    submitReview(review) {
      this.axios
        .patch(process.env.API_BASE_URL + `/reviews/${review.id}`, review, {
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.token,
          },
        })
        .then((_response) => {
          this.$router.push("/submissions");
        });
    },
    submitReviews() {
      this.reviews.forEach((review) => {
        if (review.user_id > 0) {
          if (review.id) {
            this.axios
              .patch(
                process.env.API_BASE_URL + `/reviews/${review.id}`,
                review,
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.auth.token,
                  },
                }
              )
              .then((_response) => {
                this.$router.push("/submissions");
              });
          } else {
            this.axios
              .post(process.env.API_BASE_URL + `/reviews`, review, {
                headers: {
                  Authorization: "Bearer " + this.$store.state.auth.token,
                },
              })
              .then((_response) => {
                this.$router.push("/submissions");
              });
          }
        } else {
          this.$router.push("/submissions");
        }
      });
    },
    updateStatus: function() {
      this.axios
        .patch(
          process.env.API_BASE_URL + '/articles/' + this.articleId,
          {
            status: Number(this.status)
          },
          {
            headers: { 
              Authorization: "Bearer " + this.$store.state.auth.token
            },
          }
        )
        .then(function(response) {
          this.validation = response.data;
        })
        .catch(function(error) {
          this.validation = error;
        });
    }
  },
};
</script>

<style lang="scss">
.yellow {
  background-color: #fdee21;
  .tit {
    background-color: white;
  }
}
.status-select {
  width: 200px !important;
  margin: 10px 0 30px 0;
  height: 50px !important;
}
input[type="submit"] {
  margin-left: 15px;
  margin-bottom: 2em;
  background: #fdee21;
  border: 1px solid #000;
  border-radius: 0;
  color: #000;
  text-shadow: none;
  font-size: 18px;
  padding: 10px;
  display: inline-block;
  &:hover {
    color: #000;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// ReviewPage.vue?607fb5d5